var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'vue-numeric-input',
    _vm.size,
    _vm.controlsType === 'updown' ? 'updown' : ''
  ]},[_c('formatted-number-input',{staticClass:"numeric-input",attrs:{"value":_vm.newValue,"nullValue":_vm.initialNumber,"decimal":",","separator":"."},on:{"change":_vm.submit,"input":_vm.emitPreview}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }